import React, { Component } from 'react';
import cx from 'classnames';
import BEMHelper from 'react-bem-helper';
import mailSentImage from '../../../Assets/images/mail-sent.png';
import './EmailSent.scss';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  setSignupEmail,
  setSignupActive,
} from '../../../Actions/actions_signup';

const bem = BEMHelper({ name: 'EmailSent', outputIsString: true });

class EmailSent extends Component {
  constructor(props) {
    super(props);
    this.backToSignUp = this.backToSignUp.bind(this);
  }

  backToSignUp() {
    this.props.setSignupEmail('');
    localStorage.removeItem('email_verification_to');
    this.props.setSignupActive();
  }

  render() {
    return (
      <div className={bem()}>
        <div className={cx(bem('container'), 'flex flex-col items-center')}>
          <img
            className={bem('sent-img')}
            src={mailSentImage}
            alt="Mail Sent"
          />
          <h3 className={cx(bem('title'), 'mb-8')}>
            Congratulations, you&apos;re almost there...
          </h3>
          <p className={bem('description')}>
            Check your inbox at {this.props.email} for a confirmation email.
            Click the button in your email and you&apos;ll be good to go!
          </p>
          <div className={bem('help-divider')} />
          <h4 className={bem('subtitle')}>Can&apos;t find the email? Try:</h4>
          <ul className={bem('help-list')}>
            <li>Checking the spam folder.</li>
            <li>
              {'Contact us at '}
              <a href="mailto:support@getmotivatedbuddies.com">
                support@getmotivatedbuddies.com
              </a>
              .
            </li>
          </ul>

          <p>
            {' '}
            Not your email?{' '}
            <a style={{ textDecoration: 'none' }} onClick={this.backToSignUp}>
              {' '}
              Sign up{' '}
            </a>
          </p>
        </div>
      </div>
    );
  }
}

EmailSent.propTypes = {
  email: PropTypes.string,
  setSignupEmail: PropTypes.func,
  setSignupActive: PropTypes.func,
};

const mapStateToProps = (state) => ({
  email: state.signup.email,
});

export default connect(mapStateToProps, {
  setSignupEmail: setSignupEmail,
  setSignupActive: setSignupActive,
})(EmailSent);
